import React from "react";
import { Redirect, Route } from "react-router-dom";
import { useOcCurrentUserState } from "oc/hooks";
import { useMyHrUserRolesDataByContract } from "my-hr/hooks";
import { OcLoading } from "oc/components";

interface OcPrivateRouteProps {
  children: React.ReactNode;
  isLoggedIn: boolean;
  roles?: string[];
  [key: string]: any;
}

export const OcPrivateRoute: React.FC<OcPrivateRouteProps> = ({
  children,
  isLoggedIn,
  roles = [],
  ...rest
}) => {
  const { contractCode } = useOcCurrentUserState();
  const { hasRole, loading } = useMyHrUserRolesDataByContract({
    contract: contractCode,
  });

  return (
    <Route
      {...rest}
      render={({ location }) => {
        // 1. Login check
        if (!isLoggedIn) {
          return (
            <Redirect
              to={{
                pathname: "/login",
                state: { from: location },
              }}
            />
          );
        }

        // 2. Role loading state
        if (loading && roles.length > 0) {
          return <OcLoading show />;
        }

        // 3. Role check (only if roles are specified)
        if (roles.length > 0) {
          if (!hasRole(roles, [])) {
            // No permission - redirect to home
            return <Redirect to="/" />;
          }
        }

        // 4. All checks passed
        return children;
      }}
    />
  );
};

export default OcPrivateRoute;
